<template>
    <b-alert :show="show" :variant="variant">{{message}}</b-alert>
</template>

<script>
    import {mapState, mapGetters} from 'vuex';

    export default {
        name: "Alert",
        computed: {
            ...mapState('alerts', ['variant', 'message']),
            ...mapGetters('alerts', ['show']),
        }
    }
</script>

<style scoped>

</style>